import { useTranslations } from '@vocab/react';
import { Box, Text } from 'braid-design-system';
import type { FC } from 'react';

import translations from './.vocab';

import * as styles from './styles.css';

export const TableHeader: FC = () => {
  const { t } = useTranslations(translations);

  return (
    <Box
      background="neutralLight"
      paddingY="small"
      paddingX="medium"
      className={styles.tableRowLayout}
    >
      <Text size="small" weight="strong">
        {t('Name')}
      </Text>

      <Text size="small" weight="strong">
        {t('Status')}
      </Text>

      <Text size="small" weight="strong">
        {t('Most recent role')}
      </Text>

      <Text size="small" weight="strong">
        {t('Most recent application')}
      </Text>

      <Text size="small" weight="strong" align={['left', 'right']}>
        {t('Previous applications')}
      </Text>

      <Text size="small" weight="strong" align={['left', 'right']}>
        {t('Actions')}
      </Text>
    </Box>
  );
};
